import type { FC, ReactElement } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { useFeature } from '../../services/features/reactBindings/hooks';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { Modal } from '../modal/modal/Modal';

import { QuickGuidePlain } from './QuickGuidePlain';

export const QuickGuideModalConnected: FC = (): ReactElement | null => {
  const dispatch = useCoreDispatch();
  const { quickGuideContent } = useGameConfig();
  const newLayout = useFeature('newLayout');

  if (!quickGuideContent) return null;

  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;

  const handleClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
  };

  return (
    <Modal
      data-testid="quick-guide-modal"
      draggable
      fullScreenNoClose
      grow
      newLayout={newLayout}
      heightAdjustment={heightAdjustment}
      limitedHeight="var(--game-quick-guide-max-height)"
      onClose={handleClose}
      open={openedModal === HeaderModal.QuickGuide}
      originX="end"
      tk="QG_QUICK_GUIDE"
    >
      <QuickGuidePlain
        isOpen={openedModal === HeaderModal.QuickGuide}
        listItems={quickGuideContent}
        onPlayAction={handleClose}
      />
    </Modal>
  );
};
